import { zSeparator } from "src/common/attrView/viewFormItems/Separator";
import { zRolesViewAtts } from "src/common/roles/ZRolesViewAtts";
import { z } from "zod";

export const zAttrPersonSelect = z.object({
  editor: z.literal("PersonSelect"),
  multiple: z.boolean().optional(),
  rolesViewAtts: zRolesViewAtts,
  separator: zSeparator.optional().nullable(),
});

export type ZAttrPersonSelect = z.infer<typeof zAttrPersonSelect>;

export type AttrPersonSelectProps = Omit<ZAttrPersonSelect, "editor">;

export const makeAttrPersonSelectProps = (
  src: ZAttrPersonSelect,
): AttrPersonSelectProps => {
  const { editor, ...rest } = src;
  return rest;
};
